import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
} from '@material-ui/core'
/* eslint-disable import/order */
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import { Field, FieldArray, Form, Formik, useFormikContext } from 'formik'
import { Switch, TextField as TextFieldOr } from 'formik-material-ui'
import { Autocomplete } from 'formik-material-ui-lab'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AddIcon from '@material-ui/icons/Add'
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline'

import styles from '../../../resources/theme/global'
import {
  generatePayment,
  getAttendanceComments,
  getPaymentInformation,
} from '../AttendanceActions'
import NumberFormatCustom from '../../components/NumberFormat'
import { exportFormatedMoney } from '../../../util/utils'
import { KeyboardDatePicker } from 'formik-material-ui-pickers'
import { format, isAfter, startOfDay } from 'date-fns'
import colors from '../../../assets/colors'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'

// Só permite marcar o pagamento como compensado quando a data do pagamento
// não é futura (dia estritamente após hoje).
const isPaymentDateInFuture = date =>
  date ? isAfter(startOfDay(new Date(date)), startOfDay(new Date())) : false

// Reseta o "paid" para false quando a data do pagamento passa a ser futura.
function PaidFieldResetter({ name, paid, disabled }) {
  const { setFieldValue } = useFormikContext()

  useEffect(() => {
    if (disabled && paid) {
      setFieldValue(name, false)
    }
  }, [disabled, paid, name, setFieldValue])

  return null
}

function PaymentDetails(props) {
  const { classes } = props
  const dispatch = useDispatch()
  const [comments, setComments] = useState('')
  const [paymentInformation, setPaymentInformation] = useState('')

  const styles = filterStylesComponents()

  const paymentMethods = useSelector(state => state.attendance.paymentMethods)
  const banks = useSelector(state => state.attendance.banks)

  const onSubmit = values => {
    const { id } = props.match.params
    dispatch(generatePayment(id, values)).then(data => {
      if (data && data.code === 200) {
        props.history.goBack()
      }
    })
  }

  useEffect(() => {
    async function init() {
      const { id } = props.match.params
      const resp = await dispatch(getAttendanceComments(id))
      setComments(resp?.data)

      const fetchPaymentInformation = await dispatch(getPaymentInformation(id))
      setPaymentInformation(fetchPaymentInformation?.data)
    }

    init()
  }, [])

  const onClose = () => {
    props.history.goBack()
  }

  return (
    <BaseFilterModal
      title="Forma de pagamento"
      open
      handleOpen={onClose}
      hiddenHelpButton
    >
      <Grid
        container
        xs={12}
        item
        direction="row"
        style={{ width: '1000px', maxWidth: '100%' }}
      >
        <Formik
          initialValues={{
            payment_details: '',
            billings: [
              {
                paymentMethod: null,
                value: null,
                bank: null,
                paid: false,
                payment_date: null,
              },
            ],
          }}
          enableReinitialize
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(false)
            const data = {
              ...values,
            }
            data.billings.map(item => {
              item.payment_date = item.payment_date
                ? format(new Date(item.payment_date), 'yyyy-MM-dd')
                : null

              return item
            })

            onSubmit && onSubmit(data)
          }}
        >
          {({ submitForm, isSubmitting, values, handleChange }) => (
            <Form style={{ width: '100%' }}>
              <Paper elevation={5}>
                <FieldArray name="billings">
                  {({ push, remove }) => (
                    <div className={classes.laundryTechniciansContainer}>
                      <Grid container spacing={1}>
                        <Grid item xs>
                          <Typography
                            color="primary"
                            variant="h6"
                            style={{ color: colors.primary }}
                          >
                            {`Recebimento - OS: ${
                              paymentInformation.os || ''
                            }  - Cliente: ${
                              paymentInformation.client_name || ''
                            } - Valor Total: ${exportFormatedMoney(
                              paymentInformation.value || ''
                            )}`}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Button
                            onClick={() =>
                              push({
                                paymentMethod: null,
                                value: null,
                                bank: null,
                                paid: false,
                                payment_date: null,
                              })
                            }
                          >
                            <AddIcon />
                          </Button>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            color="primary"
                            style={{ color: colors.textGray, fontSize: '12px' }}
                          >
                            {`Valor total sem cashback aplicado: ${exportFormatedMoney(
                              paymentInformation.value_without_cashback || ''
                            )}`}
                          </Typography>
                        </Grid>
                      </Grid>
                      {values.billings?.map((item, index) => {
                        const disablePaid = isPaymentDateInFuture(
                          item.payment_date
                        )

                        return (
                          <Box key={String(index)}>
                            <PaidFieldResetter
                              name={`billings[${index}].paid`}
                              paid={item.paid}
                              disabled={disablePaid}
                            />
                            <Grid
                              container
                              spacing={1}
                              style={{ margin: '10px 0px' }}
                            >
                              <Grid
                                item
                                xs={3}
                                style={{ alignSelf: 'flex-end' }}
                              >
                                <Field
                                  name={`billings[${index}].paymentMethod`}
                                  component={Autocomplete}
                                  options={paymentMethods}
                                  getOptionSelected={(option, value) =>
                                    option.id === value.id
                                  }
                                  getOptionLabel={option => option.name}
                                  renderInput={params => (
                                    <TextField
                                      {...params}
                                      label="Método de pagamento"
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={2}>
                                <Field name={`billings[${index}].value`}>
                                  {({ field }) => (
                                    <TextField
                                      {...field}
                                      label="Valor"
                                      onChange={handleChange(
                                        `billings[${index}].value`
                                      )}
                                      fullWidth
                                      InputProps={{
                                        inputComponent: NumberFormatCustom,
                                      }}
                                    />
                                  )}
                                </Field>
                              </Grid>

                              <Grid item xs={2}>
                                <Field
                                  component={KeyboardDatePicker}
                                  name={`billings[${index}].payment_date`}
                                  clearable
                                  clearLabel="Limpar"
                                  label="Data do pagamento"
                                  autoOk
                                  format="dd/MM/yyyy"
                                />
                              </Grid>

                              <Grid item xs={2}>
                                <Field
                                  name={`billings[${index}].bank`}
                                  component={Autocomplete}
                                  options={banks}
                                  getOptionSelected={(option, value) =>
                                    option.id === value.id
                                  }
                                  getOptionLabel={option => option.name}
                                  renderInput={params => (
                                    <TextField {...params} label="Banco" />
                                  )}
                                />
                              </Grid>

                              <Grid
                                item
                                xs={2}
                                style={{ alignSelf: 'flex-end' }}
                              >
                                <FormControlLabel
                                  control={
                                    <Field
                                      component={Switch}
                                      type="checkbox"
                                      name={`billings[${index}].paid`}
                                      disabled={disablePaid}
                                    />
                                  }
                                  label="Pagamento já compensado?"
                                />
                                {disablePaid && (
                                  <Typography
                                    style={{
                                      fontSize: '12px',
                                      color: colors.graylight,
                                    }}
                                  >
                                    Você não pode dar baixa em um pagamento com
                                    data do pagamento futura.
                                  </Typography>
                                )}
                              </Grid>

                              <Grid item xs style={{ alignSelf: 'flex-end' }}>
                                <Button
                                  color="inherit"
                                  onClick={() => remove(index)}
                                  aria-label="Close"
                                >
                                  <RemoveCircleOutlineIcon />
                                </Button>
                              </Grid>
                            </Grid>
                          </Box>
                        )
                      })}
                    </div>
                  )}
                </FieldArray>
              </Paper>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Field
                    name="payment_details"
                    component={TextFieldOr}
                    variant="outlined"
                    placeholder="Descrição"
                    fullWidth
                    multiline
                    rows={5}
                    rowsMax={10}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    placeholder="Comentários do Técnico..."
                    fullWidth
                    multiline
                    disabled
                    value={comments}
                    rows={5}
                    rowsMax={10}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <Grid item>
                    <Button onClick={onClose}>Cancelar</Button>
                  </Grid>
                  <Grid item>
                    <Button
                      disabled={isSubmitting}
                      onClick={submitForm}
                      className={styles.btnSalvar}
                    >
                      Salvar
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Grid>
    </BaseFilterModal>
  )
}

export default withStyles(styles)(PaymentDetails)
